import BackendService from './BackendService';

export default class AppConfigurationService {
  static getAppConfiguration(appId) {
    return BackendService.get(`/appConfigurations/${appId}`);
  }

  static createAppConfiguration(appConfiguration) {
    return BackendService.post('/appConfigurations/', {
      body: appConfiguration,
    });
  }

  static updateAppConfiguration(appConfiguration) {
    return BackendService.put(`/appConfigurations/${appConfiguration.id}`, {
      body: appConfiguration,
    });
  }
}
